import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://brand.bagself.com';
const SITE_NAME = 'COBRAND';
const DEFAULT_IMAGE = `${BASE_URL}/og-image.jpg`;

interface SEOProps {
  title?: string;         // 페이지 제목 (| COBRAND 자동 추가)
  description?: string;
  keywords?: string;
  path?: string;          // 현재 경로 (canonical 자동 생성)
  image?: string;
  type?: 'website' | 'product' | 'article';
  noIndex?: boolean;
  structuredData?: object; // JSON-LD 추가 데이터
}

export default function SEO({
  title,
  description = 'COBRAND는 디자인·소재·생산·유통 전문 파트너사가 협력하는 전문 브랜드 가방 제작·유통 회사입니다.',
  keywords   = '가방제작,OEM,ODM,핸드백,백팩,크로스백,가방브랜드,COBRAND',
  path       = '',
  image      = DEFAULT_IMAGE,
  type       = 'website',
  noIndex    = false,
  structuredData,
}: SEOProps) {
  const fullTitle  = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | 전문 브랜드 가방 제작·유통`;
  const canonical  = `${BASE_URL}${path}`;

  return (
    <Helmet>
      {/* 기본 */}
      <html lang="ko" />
      <title>{fullTitle}</title>
      <meta name="description"    content={description} />
      <meta name="keywords"       content={keywords} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical"       href={canonical} />

      {/* Open Graph */}
      <meta property="og:type"        content={type} />
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:title"       content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url"         content={canonical} />
      <meta property="og:image"       content={image} />
      <meta property="og:locale"      content="ko_KR" />

      {/* Twitter Card */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image"       content={image} />

      {/* JSON-LD 구조화 데이터 */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
